import { Injectable, inject } from '@angular/core';

import { Logger } from '@frontend/vanilla/core';
import Dexie, { Table } from 'dexie';

import { LobbyItemBaseModel } from '../casino-lobby-manager/lobby-details-model/lobby-item.model';
import { ICacheItem } from '../shared/localstorage.expirable.persistence.service';
import { DBTableSchemas, IIndexedDBCacheItem } from './indexed-db.model';
import { IndexedDBService } from './indexed-db.service';

@Injectable({
    providedIn: 'root',
})
export class IndexedDBManager extends Dexie {
    lobbyFeed!: Table<IIndexedDBCacheItem, string>;

    indexedDBService = inject(IndexedDBService);
    logger = inject(Logger);

    getIndexedDbStore(): Table<IIndexedDBCacheItem, string> {
        // "We'll take `DBTableSchemas` as an argument from the caller.
        // Currently, it supports one table, but handling multiple tables for IndexedDB will be addressed in the next task, when we have multiple tables schema ready
        return this.indexedDBService.table(DBTableSchemas[0].name);
    }

    async read<T>(cacheKey: string, lmtExpirationTime: number): Promise<T | undefined | LobbyItemBaseModel | null> {
        const cachedItem: ICacheItem | undefined = await this.getIndexedDbStore().get(cacheKey);

        if (cachedItem) {
            const cachedAt = cachedItem.createdAt;
            const resolveData = cachedAt && new Date().getTime() - cachedAt < lmtExpirationTime ? cachedItem.value : null;

            if (!resolveData) {
                await this.getIndexedDbStore().clear();
            }

            return resolveData;
        }

        return undefined;
    }

    write(key: string, cacheValue: any): void {
        if (key?.trim() && cacheValue) {
            const cachedItem: IIndexedDBCacheItem = { cacheKey: key.trim(), createdAt: new Date().getTime(), value: cacheValue };
            this.getIndexedDbStore()
                .put(cachedItem)
                .catch((err) => this.logger.error('Unable to add the lobby feed to IndexedDB, ', err));
        }
    }

    // for now we are adding `any` but there is an ongoing work to remove it and instead introduce proper data models through out the flow of LMTFEED Data
}
